import { isMobile, isLite, UniqueId, ActiveLanguage } from 'shared/vidio_helpers';
import AhoyEvent from 'shared/ahoy_event';
import LocationAdapter from 'shared/location_adapter';
import $ from 'jquery';

const mobileVerificationView = require('templates/mobile/phone_verification_modal.jst.jade');
const desktopVerificationView = require('templates/desktop/phone_verification_modal.jst.jade');

export default class PhoneVerificationModal {
  constructor(params={}) {
    const lang = ActiveLanguage.get();
    this.body = document.querySelector('body');
    this.$modal = null;
    this.phone_uuid = null;
    this.data = {
      locale: window.Locale[lang].phone_verification_modal
    };

    this.callbacks = {
      onShowPhoneSection: params.onShowPhoneSection,
      onVerificationSuccess: params.onVerificationSuccess,
      onSuccessSectionModalClosed: params.onSuccessSectionModalClosed
    };
    this.exceedVerificationSendLimitErrorCode = 10020001;
    this.verifiedByAnotherUserErrorCode = 10020012;
  }

  init() {
    this.renderModal();
    this.initElements();
    this.initCloseModalHandler();
    this.initPhoneSection();
    this.initVerifyCodeSection();
    this.initSuccessSection();
    this.initErrorSection();
  }

  renderModal() {
    this.$modal = this.getTemplate();
    $('body').append(this.$modal);
  }

  getTemplate() {
    if (isMobile() || isLite()) {
      return $(mobileVerificationView(this.data));
    } else {
      return $(desktopVerificationView(this.data));
    }
  }

  initElements() {
    this.$overlay = this.$modal.find('.phone-verification-modal__overlay');
    this.$closeButton = this.$modal.find('.phone-verification-modal__close');

    this.$phoneSection = this.$modal.find('.phone-verification-modal__section--phone');
    this.$phoneForm = this.$phoneSection.find('.phone-verification-modal__form');
    this.$phoneFormInput = this.$phoneSection.find('.phone-verification-modal__form-input--phone');
    this.$phoneFormButton = this.$phoneSection.find('.phone-verification-modal__form-button');
    this.$phoneFormError = this.$phoneSection.find('.phone-verification-modal__form-error');

    this.$verifyCodeSection = this.$modal.find('.phone-verification-modal__section--verify-code');
    this.$verifyCodePhone = this.$verifyCodeSection.find('.phone-verification-modal__phone-for-verification');
    this.$verifyCodeInputs = this.$verifyCodeSection.find('.phone-verification-modal__verification-code-input > input');
    this.$verifyCodeResendCodeText = this.$verifyCodeSection.find('.phone-verification-modal__resend-code__text');
    this.$verifyCodeResendCodeCountdown = this.$verifyCodeSection.find('.phone-verification-modal__resend-code__countdown');
    this.$verifyCodeResendCodeLink = this.$verifyCodeSection.find('.phone-verification-modal__resend-code > .phone-verification-modal__link');
    this.$verifyCodeFormError = this.$verifyCodeSection.find('.phone-verification-modal__form-error');

    this.$successSection = this.$modal.find('.phone-verification-modal__section--success');
    this.$successSectionButton = this.$successSection.find('.phone-verification-modal__form-button');

    this.$errorSection = this.$modal.find('.phone-verification-modal__section--error');
    this.$errorSectionDescription = this.$errorSection.find('.phone-verification-modal__description');
    this.$errorSectionButton = this.$errorSection.find('.phone-verification-modal__form-button');
  }

  initCloseModalHandler() {
    this.$overlay.on('click', this.closeModal.bind(this));
    this.$closeButton.on('click', this.closeModal.bind(this));
  }

  initPhoneSection() {
    this.$phoneFormInput.on('input', this.onInputOnlyAllowNumber.bind(this));
    this.$phoneFormInput.on('input', this.onInputLimitMaxLength.bind(this, 17));
    this.$phoneFormInput.on('keyup', this.onKeyUpValidatePhoneInputMinLength.bind(this));
    this.$phoneForm.on('submit', this.onSubmitPhoneForm.bind(this));
  }

  initVerifyCodeSection() {
    this.$verifyCodeResendCodeLink.on('click', this.resendCode.bind(this));
    this.$verifyCodeInputs.on('input', this.onInputOnlyAllowNumber.bind(this));
    this.$verifyCodeInputs.on('input', this.onInputLimitMaxLength.bind(this, 1));
    this.$verifyCodeInputs.on('keyup', this.onVerifyCodeInputKeyUp.bind(this));
    this.$verifyCodeInputs.on('click', this.onVerifyCodeInputClick.bind(this));
  }

  initSuccessSection() {
    this.$successSectionButton.on('click', this.onClickSuccessSectionButton.bind(this));
  }

  initErrorSection() {
    this.$errorSectionButton.on('click', this.closeModal.bind(this));
  }

  /***************************
   * Phone Section functions *
   ***************************/

  onKeyUpValidatePhoneInputMinLength(e) {
    let minLength = 9;
    let length = e.target.value.length;

    if (length < minLength) {
      this.$phoneFormButton.prop('disabled', true);
      this.showPhoneFormError(this.data.locale.phone_section.invalid_phone_number);
    } else {
      this.hidePhoneFormError();
      this.$phoneFormButton.prop('disabled', false);
    }
  }

  onSubmitPhoneForm(e) {
    e.preventDefault();
    this.$phoneFormButton.prop('disabled', true);

    let phoneNumber = this.getPhoneNumber();
    let successCallback = function() {
      this.sendAhoyEvent('submit','phone_number', 'success');
      this.showVerifyCodeSection(phoneNumber);
    }.bind(this);
    let failCallback = function(xhr) {
      if (xhr.responseJSON != undefined) {
        if(xhr.responseJSON.error_code == this.exceedVerificationSendLimitErrorCode) {
          this.showReachMaximumError();
        } else if(xhr.responseJSON.error_code == this.verifiedByAnotherUserErrorCode) {
          this.showVerifiedByAnotherUserError();
        } else {
          this.showPhoneFormError(xhr.responseJSON.error_message);
        }
        this.sendAhoyEvent('submit','phone_number', 'failed', xhr.responseJSON.error_message);
      }
    }.bind(this);
    this.getVerificationCode(phoneNumber, successCallback, failCallback);
  }

  getVerificationCode(phoneNumber, successCallback, failCallback) {
    $.ajax({
      method: 'POST',
      url: '/dashboard/setting/phone/send_verification_code',
      data: { 'phone': phoneNumber }
    }).done( () => {
      successCallback();
    }).fail( xhr => {
      failCallback(xhr);
    });
  }

  getPhoneNumber() {
    return parseInt(this.$phoneFormInput.val(), 10).toString();
  }

  showPhoneFormError(error_message) {
    this.$phoneFormInput.addClass('phone-verification-modal__form-input--error');
    this.$phoneFormError.html(error_message);
    this.showElement(this.$phoneFormError);
  }

  hidePhoneFormError() {
    this.$phoneFormInput.removeClass('phone-verification-modal__form-input--error');
    this.hideElement(this.$phoneFormError);
  }

  /*********************************
   * Verify Code Section functions *
   *********************************/

  onVerifyCodeInputKeyUp(e) {
    if (e.key == 'Backspace' && e.target.value == '') {
      $(e.target).prev('input').val('');
      $(e.target).prev('input').focus();
    } else if (e.target.value != '') {
      $(e.target).next('input').focus();
    }

    let verificationCode = this.getVerifyCodeInputsValue();
    if (verificationCode.length == 6) {
      this.$verifyCodeInputs.blur();
      this.verifyCode(verificationCode);
    }
  }

  onVerifyCodeInputClick() {
    if (this.getVerifyCodeInputsValue().length == 6) {
      this.resetVerifyCodeInputs();
    } else {
      this.$verifyCodeInputs.each(function() {
        if (this.value.length == 0) {
          this.focus();
          return false;
        }
      });
    }
  }

  getVerifyCodeInputsValue() {
    return $.map(this.$verifyCodeInputs, function(input) {
      return input.value;
    }).join('');
  }

  verifyCode(verificationCode) {
    $.ajax({
      method: 'POST',
      url: '/dashboard/setting/phone/verify_code',
      data: { 'verification_code': verificationCode }
    }).done( () => {
      this.sendAhoyEvent('submit', 'verification_code','success');
      this.showSuccessSection();
      this.onVerificationSuccess();
    }).fail( xhr => {
      if (xhr.responseJSON != undefined) {
        this.showVerifyCodeFormError(xhr.responseJSON.error_message);
        this.sendAhoyEvent('submit', 'verification_code', 'failed', xhr.responseJSON.error_message);
      }
    });
  }

  resetVerifyCodeInputs() {
    this.$verifyCodeInputs.val('');
    this.$verifyCodeInputs.first().focus();
    this.hideVerifyCodeFormError();
  }

  setupTimer() {
    this.counter = 60;
    this.$verifyCodeResendCodeCountdown.html('00:00');
    this.timer = setInterval(this.reduceTimer.bind(this), 1000);
    this.hideElement(this.$verifyCodeResendCodeLink);
    this.showElement(this.$verifyCodeResendCodeText);
  }

  reduceTimer() {
    this.counter -= 1;
    this.$verifyCodeResendCodeCountdown.html(this.getFormatedCountdown(this.counter));
    if (this.counter <= 0) {
      clearInterval(this.timer);
      this.hideElement(this.$verifyCodeResendCodeText);
      this.showElement(this.$verifyCodeResendCodeLink);
    }
  }

  getFormatedCountdown(counter) {
    let minutes = ("0" + Math.floor((counter % (60*60)) / 60)).slice(-2);
    let seconds = ("0" + Math.floor(counter % 60)).slice(-2);
    return minutes + ':' + seconds;
  }

  resendCode() {
    this.setupTimer();
    this.resetVerifyCodeInputs();

    let phoneNumber = this.getPhoneNumber();
    let successCallback = function() {
      this.sendAhoyEvent('resend','verification_code', 'success');
    }.bind(this);
    let failCallback = function(xhr) {
      if (xhr.responseJSON != undefined) {
        if(xhr.responseJSON.error_code == this.exceedVerificationSendLimitErrorCode) {
          this.showReachMaximumError();
        } else {
          this.showVerifyCodeFormError(xhr.responseJSON.error_message);
        }
        this.sendAhoyEvent('resend','verification_code', 'failed', xhr.responseJSON.error_message);
      }
    }.bind(this);
    this.getVerificationCode(phoneNumber, successCallback, failCallback);
  }

  showVerifyCodeFormError(error_message) {
    this.$verifyCodeInputs.parent().addClass('phone-verification-modal__verification-code-input--error');
    this.$verifyCodeFormError.html(error_message);
    this.showElement(this.$verifyCodeFormError);
  }

  hideVerifyCodeFormError() {
    this.$verifyCodeInputs.parent().removeClass('phone-verification-modal__verification-code-input--error');
    this.hideElement(this.$verifyCodeFormError);
  }

  /*********************************
   * Success Section functions *
   *********************************/

  onClickSuccessSectionButton() {
    this.closeModal();
    if(!this.callbackIsValid(this.callbacks.onSuccessSectionModalClosed)) {
      return LocationAdapter.reload();
    }
    this.callbacks.onSuccessSectionModalClosed();
  }

  /*************
   * Analytics *
   *************/

  sendAhoyEvent(action, step, status = null, error_message = null) {
    let properties = {
      action: action,
      step: step,
      phone_uuid: this.phone_uuid
    };

    if (status == 'success' || status == 'failed') {
      properties.status = status;
    }

    if (error_message != null) {
      properties.error_message = error_message;
    }

    AhoyEvent.send('VIDIO::PHONE_VERIFICATION', properties);
  }

  /******************
   * Keyboard Event *
   ******************/

  addEscapeKeyEvent(){
    $('body').on('keydown', this.getEscapeKeyFunction());
  }

  removeEscapeKeyEvent(){
    $('body').off('keydown', this.getEscapeKeyFunction());
  }

  onEscapeKey(e){
    if(e.key == 'Escape' || e.key == 'Esc')
      this.closeModal();
  }

  /******
   * UI *
   ******/

  closeAllSections() {
    this.hideElement(this.$phoneSection);
    this.hideElement(this.$verifyCodeSection);
    this.hideElement(this.$successSection);
    this.hideElement(this.$errorSection);
  }

  showPhoneSection() {
    this.closeAllSections();
    this.showElement(this.$phoneSection);
    this.$phoneFormInput.focus();
    this.sendAhoyEvent('impression', 'phone_number');
    this.onShowPhoneSection();
  }

  showVerifyCodeSection(phone) {
    this.closeAllSections();
    this.$verifyCodePhone.html('+62' + phone);
    this.setupTimer();
    this.resetVerifyCodeInputs();
    this.showElement(this.$verifyCodeSection);
    this.$verifyCodeInputs.first().focus();
    this.sendAhoyEvent('impression', 'verification_code');
  }

  showSuccessSection() {
    this.closeAllSections();
    this.showElement(this.$successSection);
  }

  showReachMaximumError() {
    this.showErrorSection(this.data.locale.error_section.description.reach_maximum);
  }

  showVerifiedByAnotherUserError(){
    this.showErrorSection(this.data.locale.error_section.description.verified_by_another_user);
  }

  showErrorSection(errorMessage) {
    this.closeAllSections();
    this.$errorSectionDescription.html(errorMessage);
    this.showElement(this.$errorSection);
  }

  openModal() {
    this.phone_uuid = UniqueId.get();
    this.addEscapeKeyEvent();
    this.showElement(this.$modal);
    this.showPhoneSection();

    // Make sure player stays sticky and header doesn't block the player
    this.scrollToRightBelowHeader();
    this.body.classList.add('l-mobile__overflow-hidden');
  }

  closeModal() {
    this.removeEscapeKeyEvent();
    this.hideElement(this.$modal);

    this.body.classList.remove('l-mobile__overflow-hidden');
  }

  scrollToRightBelowHeader() {
    const sectionTopContainer = document.querySelector('#top');
    if(!sectionTopContainer) return;

    const sectionTopContainerHeight = sectionTopContainer.offsetHeight;

    if(window.pageYOffset <= sectionTopContainerHeight) {
      // Add 1px so that player container always sticky when open capsule and hides the header
      window.scroll(0, sectionTopContainerHeight + 1);
    }
  }

  /*************
   * Callbacks *
   *************/

  onShowPhoneSection(){
    if(!this.callbackIsValid(this.callbacks.onShowPhoneSection)) return;
    this.callbacks.onShowPhoneSection();
  }

  onVerificationSuccess() {
    if(!this.callbackIsValid(this.callbacks.onVerificationSuccess)) return;
    this.callbacks.onVerificationSuccess();
  }

  /*******************
   * General Helpers *
   *******************/

  onInputOnlyAllowNumber(e) {
    e.target.value = e.target.value.replace(/[^0-9]/g, '');
  }

  onInputLimitMaxLength(maxLength, e) {
    e.target.value = e.target.value.substring(0, maxLength);
  }

  showElement($el) {
    $el.removeClass('hide');
  }

  hideElement($el) {
    $el.addClass('hide');
  }

  getEscapeKeyFunction(){
    if(this.escapeKeyFunction == undefined) this.escapeKeyFunction = this.onEscapeKey.bind(this);
    return this.escapeKeyFunction;
  }

  callbackIsValid(callback){
    if(callback == null || callback == undefined) return false;
    if(typeof callback != "function") return false;
    return true;
  }
}
